import React from 'react'
import ParamList from '../param/ParamList'

function InterfaceDesc(props) {
    
    return (
        <div>
            <h1>{props.et_name}</h1>
            <div dangerouslySetInnerHTML={{__html:props.et_content}}></div>
            <ParamList
                et_id={props.et_id}
                et_name={props.et_name}
                eu_id={props.eu_id}
                eu_name={props.eu_name}
            />
        </div>
    )
}

export default InterfaceDesc